import React, { useEffect } from "react";
import { Shelf as ShelfType, Location as LocationType } from "/app/src/models";

type Style = {
  left?: string;
  bottom?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
};

/**
 * Renders a location element based on the provided coordinates and dimensions.
 *
 * @param {Object} param0 - An object containing the location and shelf data.
 * @param {LocationType} param0.location - The location data including coordinates and dimensions.
 * @param {ShelfType} param0.shelf - The shelf data including width and depth.
 * @returns {JSX.Element} A div element styled to represent the location.
 */
export default function Location({
  location,
  shelf,
}: {
  location: LocationType;
  shelf: ShelfType;
}) {
  const [style, setStyle] = React.useState<Style>({});

  useEffect(() => {
    if (
      location.xCoordinate &&
      location.yCoordinate &&
      location.binWidth &&
      location.binDepth &&
      location.fillLevel &&
      shelf.width &&
      shelf.depth
    ) {
      const left = (location.xCoordinate / shelf.width) * 100;
      const bottom = (location.yCoordinate / shelf.depth) * 100;
      const width = (location.binWidth / shelf.width) * 100;
      const height = (location.binDepth / shelf.depth) * 100;
      let color = "0,128,255";
      const opacity = location.fillLevel / 100;

      if (location.fillLevel === 100) {
        color = "255,0,0";
      }
      setStyle({
        left: `${left}%`,
        bottom: `${bottom}%`,
        width: `${width}%`,
        height: `${height}%`,
        backgroundColor: `rgb(${color}, ${opacity})`,
      });
    }
  }, [location, shelf]);

  return <div className="location" style={style} />;
}
